import Actions from './actions';
export const password = (state = {
  loading: true
}, action) => {
  switch (action.type) {
    case Actions.LOAD_SUCCESS:
      return {
        loading: false,
        loaded: true,
        updatedAt: action.payload
      };
    case Actions.UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updatedAt: +new Date()
      });
    case Actions.FAIL:
      return Object.assign({}, state, {
        fail: action.payload
      });
    case Actions.LOAD_FAIL:
      return {
        loading: false,
        loaded: false
      };
    case Actions.CLEAR_FAIL:
      return Object.assign({}, state, {
        fail: undefined
      });
    default:
      return state;
  }
};